import { snakeCase } from "lodash";
import * as React from "react";
import { useAuthProvider } from "../../core/authContext";
import swal from "sweetalert";
import {
  HotlyncServices,
  useGetHotlyncServicesQuery,
  usePropertyServicesQuery,
  useUpdateHotlyncServiceMutation,
} from "../../generated/graphql";

export const useServiceList = () => {
  const { getUser } = useAuthProvider();
  const property = getUser();
  const { data, loading } = usePropertyServicesQuery({
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: {
      property_id: property?.id,
    },
  });

  const computedData = React.useMemo(() => {
    if (!data) {
      return { servicesList: [], groupedServices: [] };
    }
    const parsedTaskList = data.getServices
      ? JSON.parse((data.getServices as any)?.tasklist)
      : [];
    const servicesList = Object.keys(parsedTaskList).map(snakeCase);

    return {
      servicesList,
    };
  }, [data]);
  return { ...computedData, loading };
};

const useHotlyncServices = () => {
  const { servicesList, loading: serviceListLoading } = useServiceList();
  const [editData, setEditData] = React.useState<HotlyncServices | null>(null);
  const [open, setOpen] = React.useState(false);
  const { getUser } = useAuthProvider();
  const property = getUser();

  const handleClickEditOpen = (data: HotlyncServices | null) => {
    setEditData(data);
    setOpen(true);
  };
  const [upsertHotlyncServices] = useUpdateHotlyncServiceMutation();

const syncHotlyncServices = async () => {
  try {
    for (const serviceName of servicesList) {
      await upsertHotlyncServices({
        variables: {
          hotlyncServiceInput: {
            id: "",
            name: serviceName,
            property_id: property?.id,
          },
        },
      });
    }
  } catch (err) {
    swal({
      text: `${err}`,
      icon: "error",
    });
  }
};
  const handleEditClose = () => {
    setEditData(null);
    setOpen(false);
  };

  // getHotlyncServices
  const {
    data: hotlyncServices,
    refetch: refetchHotlyncService,
    loading: loadingServices,
  } = useGetHotlyncServicesQuery({
    fetchPolicy: "network-only",
    variables: {
      property_id: property?.id,
    },
  });

  const sortedServices = hotlyncServices?.getHotlyncServices?.sort(
    (a, b) => (a?.name as any).localeCompare(b?.name) as any
  );

  return {
    Services: sortedServices,
    handleClickEditOpen,
    handleEditClose,
    editData,
    refetchHotlyncService,
    propertyId: property?.id,
    open,
    setOpen,
    loadingServices,
    serviceListLoading,
    syncHotlyncServices,
  };
};

export default useHotlyncServices;
